import createReducer from 'reducers/createReducer';
import moment from 'moment';
import { current } from 'immer';

import { TournamentOpen } from 'actions/actionTypes';
import { TOURNAMENT_GRADE_DATA } from 'utils/constants';

const INITIAL_STATE = {
  step: 1,
  terms: '',
  shopTournamentThmbnails: [
    { id: 1, imageKey: 'uploads/tournament/thumbnail/shop/thumbnail_01.png', title: 'Image1' },
    { id: 2, imageKey: 'uploads/tournament/thumbnail/shop/thumbnail_02.png', title: 'Image2' },
    { id: 3, imageKey: 'uploads/tournament/thumbnail/shop/thumbnail_03.png', title: 'Image3' },
  ],
  globalTournamentThmbnails: [
    { id: 1, imageKey: 'uploads/tournament/thumbnail/global/thumbnail_01.png', title: 'Image1' },
    { id: 2, imageKey: 'uploads/tournament/thumbnail/global/thumbnail_02.png', title: 'Image2' },
    { id: 3, imageKey: 'uploads/tournament/thumbnail/global/thumbnail_03.png', title: 'Image3' },
  ],
  courseList: [],
  courseDetails: {},
  isRequestSuccess: null,

  tournamentId: 0,

  data: {
    tournamentTypeCode: '',
    title: '',
    info: '',
    summary: '',
    password: null,
    thumbnailKey: '',
    isParticipationTargetLimit: false,
    participationTargets: [
      {
        targetName: 'Type 1',
        targetIndex: 1,
        gender: 0,
        minimumYearBirth: 0,
        maximumYearBirth: 0,
        teeBoxType: 3,
        handicap: 0,
      },
      {
        targetName: 'Type 2',
        targetIndex: 2,
        gender: 1,
        minimumYearBirth: 0,
        maximumYearBirth: 0,
        teeBoxType: 1,
        handicap: 0,
      },
    ],
    // participationGrades: [
    //   { grade: 'Rookie', isParticipation: true, handicap: 0 },
    //   { grade: 'Beginner', isParticipation: true, handicap: 0 },
    //   { grade: 'Amateur', isParticipation: true, handicap: 0 },
    //   { grade: 'SemiPro', isParticipation: true, handicap: 0 },
    //   { grade: 'Pro', isParticipation: true, handicap: 0 },
    //   { grade: 'TourPro', isParticipation: true, handicap: 0 },
    //   { grade: 'Challenger', isParticipation: true, handicap: 0 },
    // ],
    isParticipationConditionsLimit: false,
    participationConditions: [],
    startTime: moment().add(2, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).valueOf(),
    endTime: moment().add(3, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).valueOf(),
    isShotLiveBroadcast: true,
    courseCount: 1,
    courseRounds: [],

    gameHoleType: 0,
    gameSettingLevel: 2,
    difficulty: 3,
    greenSpeed: 2,
    greenHardness: 0,
    swingPlate: 0,
    holecupLocation: 3,
    concede: 1.5,
    greenLocation: 1,
    mulliganCount: 3,
    puttingLineCount: -1,
    windSpeed: 2,
    isUseGuideDistance: true,

    isCalculationGameRoundCount: true,
    isCalculationBackCount: true,
    isCalculationLastRoundStartTime: true,

    isAward: false,
    awards: [
      {
        awardName: 'Stroke 1st',
        awardIndex: 1,
        gender: -1,
        awardItems: 'Score',
        awardType: 'Stroke',
        courseId: '',
        rankingType: 1,
        startRanking: 1,
        endRanking: 1,
        awardProduct: '-',
      },
      {
        awardName: 'Stroke 2nd to 10th',
        awardIndex: 2,
        gender: -1,
        awardItems: 'Score',
        awardType: 'Stroke',
        courseId: '',
        rankingType: 2,
        startRanking: 2,
        endRanking: 10,
        awardProduct: '-',
      },
      {
        awardName: 'Longest 1st',
        awardIndex: 3,
        gender: -1,
        awardItems: 'Longest',
        awardType: '',
        courseId: '',
        rankingType: 1,
        startRanking: 1,
        endRanking: 1,
        awardProduct: '-',
      },
      {
        awardName: 'Nearpin 1st',
        awardIndex: 4,
        gender: -1,
        awardItems: 'Nearpin',
        awardType: '',
        courseId: '',
        rankingType: 1,
        startRanking: 1,
        endRanking: 1,
        awardProduct: '-',
      },
      // 시상 설정에 기본 항목으로 '홀인원' 추가
      {
        awardName: 'Hole In One',
        awardIndex: 5,
        gender: -1,
        awardItems: 'HoleInOne',
        awardType: '',
        courseId: '',
        rankingType: 2,
        startRanking: 1,
        endRanking: 1,
        awardProduct: '-',
      },
    ],
    participationShops: [{ country: 'all', province: 'all', city: 'all', shopGuid: 'all' }],
    isParticipationGradeLimit: false,
    participationGrades: TOURNAMENT_GRADE_DATA.reduce((acc, cur) => acc.concat(cur), []),
    isParticipationGradeAllChecked: true,
  },
  dataFormat: {
    participationTargets: { targetName: '', targetIndex: 1, gender: 0, minimumYearBirth: 0, maximumYearBirth: 0, teeBoxType: 1, handicap: 0 },
    courseRounds: { courseId: '', courseOrdering: 1, longestHoleNumber: 0, nearpinHoleNumber: 0, newPerioHoleNumber: [] },
    awards: {
      awardName: '',
      awardIndex: 1,
      gender: -1,
      awardItems: '',
      awardType: '',
      courseId: '',
      rankingType: 1,
      startRanking: 0,
      endRanking: 0,
      awardProduct: '',
    },
    participationShops: { country: 'all', province: 'all', city: 'all', shopGuid: 'all' },
  },
  error: {
    triggered: false,
    code:'',
    message: '',
  },
};

const reducer = createReducer(INITIAL_STATE, {
  // 이벤트
  [TournamentOpen.RESET_TOURNAMENT_DATA]: (state, action) => {
    state.step = INITIAL_STATE.step;
    state.terms = INITIAL_STATE.terms;
    state.courseList = INITIAL_STATE.courseList;
    state.courseDetails = INITIAL_STATE.courseDetails;
    state.isRequestSuccess = INITIAL_STATE.isRequestSuccess;
    state.tournamentId = INITIAL_STATE.tournamentId;
    state.data = INITIAL_STATE.data;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_OPEN_STEP]: (state, action) => {
    state.step = action.payload;
  },
  [TournamentOpen.CATCH_TOURNAMENT_PARAMS]: (state, action) => {
    state.data.tournamentTypeCode = action.payload.value;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_DATA]: (state, action) => {
    state.data[action.payload.name] = action.payload.value;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_TARGETS_DATA]: (state, action) => {
    state.data.participationTargets[action.payload.index][action.payload.name] = action.payload.value;
  },
  [TournamentOpen.RESET_TOURNAMENT_PARTICIPATION_TARGETS_DATA]: (state, action) => {
    state.data.participationTargets = state.data.participationTargets;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_GRADES_DATA]: (state, action) => {
    state.data.participationGrades[action.payload.index][action.payload.name] = action.payload.value;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_COURSE_ROUNDS_DATA]: (state, action) => {
    if (action.payload.name === 'newPerioHoleNumber') {
      state.data.courseRounds[action.payload.index][action.payload.name][action.payload.newPerioIndex] = Number(action.payload.value);
    } else {
      state.data.courseRounds[action.payload.index][action.payload.name] = Number(action.payload.value);
    }
  },
  [TournamentOpen.CHANGE_TOURNAMENT_AWARDS_DATA]: (state, action) => {
    state.data.awards[action.payload.index][action.payload.name] = action.payload.value;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATIONSHOPS_DATA]: (state, action) => {
    state.data.participationShops[action.payload.index][action.payload.name] = action.payload.value;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_ID]: (state, action) => {
    state.tournamentId = action.payload.id;
  },
  [TournamentOpen.CHANGE_TOURNAMENT_PARTICIPATION_GRADE_LIST_ITEM]: (state, action) => {
    const tempItem = { ...action.payload };
    const tempList = current(state.data.participationGrades);
    const idx = tempList.findIndex((node) => node.gradeType === tempItem.gradeType && node.stepType === tempItem.stepType);

    if (idx > -1) {
      state.data.participationGrades[idx] = tempItem;
      const afterList = current(state.data.participationGrades);
      state.data.isParticipationGradeAllChecked = afterList.length === afterList.filter((node) => node.isParticipation).length;
    }
  },
  [TournamentOpen.CHANGE_TOURNAMENT_IS_PARTICIPATION_GRADE_ALL_CHECKED]: (state, action) => {
    state.data.isParticipationGradeAllChecked = action.payload.value;
    const tempList = current(state.data.participationGrades).map((node) => ({
      ...node,
      isParticipation: action.payload.value,
      handicap: action.payload.isReset ? 0 : node.handicap,
    }));
    state.data.participationGrades = tempList;
  },

  // 매장 대회 로우 데이터 조회
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_SUCCESS]: (state, action) => {
    state.data.tournamentTypeCode = action.payload.tournamentTypeCode;
    state.data.title = action.payload.title;
    state.data.info = action.payload.info;
    state.data.summary = action.payload.summary;
    state.data.password = action.payload.password;
    state.data.thumbnailKey = action.payload.thumbnailKey;
    state.data.isParticipationTargetLimit = action.payload.isParticipationTargetLimit;
    state.data.participationTargets = action.payload.participationTargets;
    state.data.participationGrades =
      action.payload.participationGrades?.length > 0 ? action.payload.participationGrades : TOURNAMENT_GRADE_DATA.reduce((acc, cur) => acc.concat(cur), []);
    state.data.isParticipationConditionsLimit = action.payload.isParticipationConditionsLimit;
    state.data.participationConditions = action.payload.participationConditions;
    state.data.startTime = action.payload.startTime;
    state.data.endTime = action.payload.endTime;
    state.data.isShotLiveBroadcast = action.payload.isShotLiveBroadcast;
    state.data.courseCount = Number(action.payload.courseRounds.length);
    state.data.courseRounds = action.payload.courseRounds;

    state.data.gameHoleType = Number(action.payload.gameHoleType);
    state.data.gameSettingLevel = Number(action.payload.gameSettingLevel);
    state.data.difficulty = Number(action.payload.difficulty);
    state.data.greenSpeed = Number(action.payload.greenSpeed);
    state.data.greenHardness = Number(action.payload.greenHardness);
    state.data.swingPlate = Number(action.payload.swingPlate);
    state.data.holecupLocation = Number(action.payload.holecupLocation);
    state.data.concede = Number(action.payload.concede);
    state.data.greenLocation = Number(action.payload.greenLocation);
    state.data.mulliganCount = Number(action.payload.mulliganCount);
    state.data.puttingLineCount = Number(action.payload.puttingLineCount);
    state.data.windSpeed = Number(action.payload.windSpeed);
    state.data.isUseGuideDistance = action.payload.isUseGuideDistance;

    state.data.isCalculationGameRoundCount = action.payload.isCalculationGameRoundCount;
    state.data.isCalculationBackCount = action.payload.isCalculationBackCount;
    state.data.isCalculationLastRoundStartTime = action.payload.isCalculationLastRoundStartTime;

    state.data.isAward = action.payload.isAward;
    state.data.awards = action.payload.awards;
    state.data.participationShops = action.payload.participationShops;
    state.data.isParticipationGradeLimit = action.payload.isParticipationGradeLimit;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_RAW_DATA_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 약관 조회
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_SUCCESS]: (state, action) => {
    state.terms = action.payload;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_TERMS_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 코스 목록 조회
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_SUCCESS]: (state, action) => {
    state.courseList = action.payload.list;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_LIST_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 코스 상세 조회
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_SUCCESS]: (state, action) => {
    var courseRounds = [...state.data.courseRounds];

    var arrayIndex = courseRounds.findIndex((p) => p.courseId === action.payload.courseId);

    const longestHole = action.payload.hole.find((p) => p.par === 5);
    const nearpinHole = action.payload.hole.find((p) => p.par === 3);

    const outHoles = action.payload.hole.filter((p) => p.holeNumber <= 9);
    const InHoles = action.payload.hole.filter((p) => p.holeNumber > 9);

    courseRounds[arrayIndex].hole = action.payload.hole;
    if(state.tournamentId === 0) {
      courseRounds[arrayIndex].longestHoleNumber = Number(longestHole.holeNumber);
      courseRounds[arrayIndex].nearpinHoleNumber = Number(nearpinHole.holeNumber);

      courseRounds[arrayIndex].newPerioHoleNumber = [
        Number(outHoles.find((p) => p.par === 3).holeNumber),
        Number(outHoles.find((p) => p.par === 4).holeNumber),
        Number(outHoles.find((p) => p.par === 5).holeNumber),
        Number(InHoles.find((p) => p.par === 3).holeNumber),
        Number(InHoles.find((p) => p.par === 4).holeNumber),
        Number(InHoles.find((p) => p.par === 5).holeNumber),
      ];
    }

    state.data.courseRounds = courseRounds;
  },
  [TournamentOpen.LOAD_SHOP_TOURNAMENT_COURSE_DETAILS_REQUEST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },

  // 매장 대회 개설
  [TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST]: (state, action) => {
    state.isRequestSuccess = null;

    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST_SUCCESS]: (state, action) => {
    state.isRequestSuccess = true;
  },
  [TournamentOpen.ADD_SHOP_TOURNAMENT_REQUEST_FAILURE]: (state, action) => {
    state.isRequestSuccess = false;

    state.error = {
      triggered: true,
      code: action.payload?.code,
      message: action.payload?.message,
    };
  },

  // 매장 대회 개설
  [TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST]: (state, action) => {
    state.isRequestSuccess = null;

    state.error = INITIAL_STATE.error;
  },
  [TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST_SUCCESS]: (state, action) => {
    state.isRequestSuccess = true;
  },
  [TournamentOpen.MODIFY_SHOP_TOURNAMENT_REQUEST_FAILURE]: (state, action) => {
    state.isRequestSuccess = false;

    state.error = {
      triggered: true,
      message: action.payload?.errorMessage,
    };
  },
});

export default reducer;
